import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { CadastrarOficinaComponent } from './cadastrar-oficina/cadastrar-oficina.component';
import { OficinaComponent } from './oficina.component';


const routes: Routes = [
  { path: 'oficinas/cadastrar', component: CadastrarOficinaComponent,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.ATIVIDADES_ACOES_GERENCIAIS} },
  { path: 'oficinas', component: OficinaComponent ,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.ATIVIDADES_ACOES_GERENCIAIS} },
  { path: 'menu-sap/oficinas/cadastrar', component: CadastrarOficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.ATIVIDADES_PSICOSSOCIAL } },
  { path: 'menu-sap/oficinas', component: OficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.ATIVIDADES_PSICOSSOCIAL } },
  { path: 'menu-pedagogico/oficinas/cadastrar', component: CadastrarOficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.ATIVIDADE_PEDAGOGICO } },
  { path: 'menu-pedagogico/oficinas', component: OficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.ATIVIDADE_PEDAGOGICO } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OficinaRoutingModule { }
